/**
 * Industries Contact CTA Component
 * 
 * This component displays a final contact call to action section for the industries page.
 */
'use client';

import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { Heading, Text, Button } from '@/components/ui/design-system';
import { ArrowRight } from 'lucide-react';

export default function IndustriesContactCTA() {
  return (
          <section className="py-14 sm:py-20 bg-primary-800 text-primary-100 dark:bg-red-700 dark:text-gray-100 cta-section relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden -z-10">
        <div className="absolute inset-0 bg-[url('/noise.png')] opacity-[0.03] mix-blend-overlay pointer-events-none transform-gpu"></div>
        <div className="absolute right-0 bottom-0 opacity-10">
          <svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="200" cy="200" r="200" fill="url(#paint0_radial)" />
            <defs>
              <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(200 200) rotate(90) scale(200)">
                <stop stopColor="white" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </radialGradient>
            </defs>
          </svg>
        </div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Heading level={2} className="text-3xl sm:text-4xl font-bold mb-6 text-white dark:text-white">
            Ready to Elevate Your <span className="premium-gradient-text">Packaging</span>?
          </Heading>
          <Text variant="body-large" className="text-white/90 text-lg mb-8 max-w-3xl mx-auto">
            Connect with our team to discuss your industry needs and discover how our premium packaging solutions can enhance your products.
          </Text>
          <div className="flex flex-col sm:flex-row justify-center gap-4 max-w-lg mx-auto">
            <Link href="/contact" className="w-full sm:w-auto">
              <Button 
                variant="primary" 
                size="lg" 
                className="w-full whitespace-nowrap rounded-full group shadow-md dark:bg-red-500 dark:hover:bg-red-600 dark:text-white px-8"
                endIcon={<ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
              >
                Contact Us Today
              </Button>
            </Link>
            <Link href="/products" className="w-full sm:w-auto">
              <Button 
                variant="secondary" 
                size="lg"
                className="w-full whitespace-nowrap rounded-full shadow-sm px-8"
              >
                Explore Products
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
} 